import { Dispatch, SetStateAction } from 'react';

import { ImageWrapper, Image, StyledDeleteIcon, SvgWrapper } from './styled'

interface RenderImagesByBase64Props<T> {
  src: string;
  togetherImagesLength: number;
  setState: Dispatch<SetStateAction<T>>;
}

const RenderImagesByBase64 = <T, >({
  src,
  togetherImagesLength,
  setState,
}: RenderImagesByBase64Props<T>) => {
  return (
    <ImageWrapper>
      {
        togetherImagesLength > 1 && (
          <SvgWrapper
            onClick={() => {
              setState((prev) => ({ ...prev, imageUrl: src, isDeleteModalOpen: true }))
            }}
          >
            <StyledDeleteIcon />
          </SvgWrapper>
        )
      }
      <Image
        src={src}
        alt="product"
        onClick={() => {
          setState((prev) => ({ ...prev, imageUrl: src, isViewImageModalOpen: true }))
        }}
      />
    </ImageWrapper>
  )
}

export default RenderImagesByBase64;
